import React, { useRef } from 'react';
import { MIconInteractiveProps } from './MIconInteractive.types';
import * as Styled from './MIconInteractive.styles';
import { AIcon } from '../../atoms/AIcon';
import { useTracking } from '../../hooks';

const COMPONENT_NAME = 'm-web-ui-kit-MIconInteractive';
const TEST_ID = 'web-ui-kit-MIconInteractive';

export function MIconInteractive({
  aIcon,
  ctaLink,
  openInANewTab,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ariaLabel,
  trackingProperties,
  custom_click_track_value,
}: MIconInteractiveProps) {
  const ref = useRef<HTMLElement>(null);
  const content = aIcon ? <AIcon {...aIcon} /> : null;

  const opensInNewTab = openInANewTab === true || openInANewTab === 'true';
  const isExternal = !!ctaLink && opensInNewTab;

  useTracking({
    ref,
    trackingProperties,
    isExternal,
    custom_click_track_value,
  });

  if (ctaLink) {
    return (
      <Styled.AnchorWrapper
        ref={ref as React.RefObject<HTMLAnchorElement>}
        href={ctaLink}
        target={opensInNewTab ? '_blank' : '_self'}
        rel={opensInNewTab ? 'noopener noreferrer' : undefined}
        aria-label={ariaLabel}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-component-name={COMPONENT_NAME}
        data-testid={TEST_ID}
      >
        {content}
      </Styled.AnchorWrapper>
    );
  }

  return (
    <Styled.Wrapper
      ref={ref as React.RefObject<HTMLButtonElement>}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
    >
      {content}
    </Styled.Wrapper>
  );
}
